import API from './API';
import AlbumActions from 'actions/AlbumActions';

const AlbumSource = {
  fetchAlbumList: {
    remote(state) {
      let url = `${API.getAlbumList}&first=${state.first}&maxCount=${state.maxCount}`;
      return fetch(url).then(res=>res.json());
    },
    // local(state) {
    //   return null;
    // },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.fetchAlbumListSuccess,
    error: AlbumActions.fetchFailed
  },
  fetchUserAlbumList: {
    remote(state) {
      let url = `${API.getUserAlbum}&first=${state.userFirst}&maxCount=${state.userMaxCount}&breif=true`;
      return fetch(url).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: AlbumActions.fetchUserAlbumListSuccess,
    error: AlbumActions.fetchFailed
  },
  postAlbum: {
    remote(state) {
      let data = `name=${state.newAlbumName}&desc=&cover=&accessToken=${API.accessToken}`;
      let param = {
        method: 'POST',
        body: data,
        headers: API.urlHeader
      };
      return fetch(API.postAlbum, param).then(res=>res.json());
    },
    // local(state) {
    //   return null;
    // },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.postAlbumSuccess,
    error: AlbumActions.fetchFailed
  },
  updateAlbum: {
    remote(state) {
      let data = `name=${state.newAlbumName}&desc=${state.newAlbumDesc}&cover=&accessToken=${API.accessToken}`;
      let param = {
        method: 'POST',
        body: data,
        headers: API.urlHeader
      };
      return fetch(API.postUpdateAlbum.replace(':id', state.album_id), param).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.updateAlbumSuccess,
    error: AlbumActions.fetchFailed
  },
  deleteAlbum: {
    remote(state) {
      let param = {
        method: 'POST',
        body: JSON.stringify({album_id:state.album_id}),
        headers: API.jsonHeader
      };
      return fetch(API.deleteAlbum, param).then(res=>res.json()).then(json=>{
        json.updateFnName = 'deleteAlbum';
        return json;
      });
    },
    shouldFetch(state) {
      return true; 
    },
    success: AlbumActions.deleteAlbumSuccess,
    error: AlbumActions.fetchFailed
  },
  postAlbumAddMedia: {
    remote(state) {
      let data = `media_id=${state.postParam.media_id}&accessToken=${API.accessToken}`;
      let param = {
        method: 'POST',
        body: data,
        headers: API.urlHeader
      };
      return fetch(API.postAlbumAddMedia.replace(':id', state.postParam.album_id), param).then(res=>res.json());
    },
    // local(state) {
    //   return null;
    // },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.postAlbumAddMediaSuccess,
    error: AlbumActions.fetchFailed
  },
  fetchAlbumDetail: {
    remote(state) {
      return fetch(API.getAlbumDetail.replace(':id', state.album_id)).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.fetchAlbumDetailSuccess,
    error: AlbumActions.fetchFailed
  },
  fetchAlbumMedia: {
    remote(state) {
      let url = `${API.getAlbumMedia.replace(':id', state.album_id)}&first=${state.mediasFirst}&maxCount=${state.mediasMaxCount}`;
      return fetch(url).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.fetchAlbumMediaSuccess,
    error: AlbumActions.fetchFailed
  },
  fetchAlbumArticleMedia: {
    remote(state) {
      let url = `${API.getAlbumArticleMedia.replace(':id', state.album_id)}&first=0&maxCount=30`;
      return fetch(url).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.fetchAlbumArticleMediaSuccess,
    error: AlbumActions.fetchFailed
  },
  postCollectAlbum: {
    remote(state) {
      let url;
      if(state.isCollect) {
        url = API.postUncollectAlbum;
      } else {
        url = API.postCollectAlbum;
      }
      let params = {
        method: 'POST',
        body: `accessToken=${API.accessToken}`,
        headers: API.urlHeader
      };
      return fetch(url.replace(':id', state.album_id), params).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    // loading() {},
    success: AlbumActions.postCollectAlbumSuccess,
    error: AlbumActions.fetchFailed
  }
};

export default AlbumSource;



// WEBPACK FOOTER //
// ./src/sources/AlbumSource.js